<div id="mail-confirm" fxLayout="column">

    <div id="mail-confirm-form-wrapper" fxLayout="column" fxLayoutAlign="center center">

        <div id="mail-confirm-form" [@animate]="{value:'*',params:{duration:'300ms',y:'100px'}}">

            <div class="logo">
                <mat-icon class="mat-accent s-96">email</mat-icon>
            </div>

            <div class="title" *ngIf="!isAdvisorCitizen">¡Cuenta creada satisfactoriamente!</div>
            <div class="title" *ngIf="isAdvisorCitizen">¡Asesoría creada satisfactoriamente!</div>

            <div class="subtitle">
                <p>
                   <!--  Un Asesor Ciudadano se pondrá en contacto contigo a través del correo que has proporcionado.<br> -->
                    Verifique su bandeja de entrada principal o correo no deseado
                </p>
            </div>

            <div class="message">
                <a class="link" *ngIf="!isAdvisorCitizen" [routerLink]="'/pages/auth/login'">Iniciar sesión</a>
                <a class="link" *ngIf="isAdvisorCitizen" [routerLink]="'/inicio'">Inicio plataforma</a>
            </div>

        </div>

    </div>

</div>
